import Image from 'next/image';

import { PicturePasswordItem } from './shared';

import styles from './PicturePasswordPreview.module.scss';

interface PicturePasswordPreviewProps {
  password: PicturePasswordItem[];
  size?: number;
}

export const PicturePasswordPreview = ({ password, size = 48 }: PicturePasswordPreviewProps) => {
  if (password.length === 0) {
    return null;
  }
  return (
    <>
      {password.map(({ altText, imageUrl, value }) => (
        // we can use value for key as picture passwords do not use repeated symbols
        <span key={value} className={styles.item}>
          <Image src={imageUrl} alt={altText} width={size} height={size} />
        </span>
      ))}
    </>
  );
};
